import { useEffect, useRef } from 'react';
import { getSupabase, isSupabaseConfigured } from '../lib/supabase';
import { isGuestStorage, isLoggedInStorage } from '../lib/onboardingStorage';
import { fetchMyAppUserRow } from '../api/profileApi';
import { tryAwardDailyLogin } from '../api/pointsApi';
import { useMingo } from '../context/MingoContext';

/** Once per day per user while logged in (non-guest). */
export function useDailyLoginPoints() {
  const ran = useRef(false);
  const { showToast, t } = useMingo();

  useEffect(() => {
    if (!isSupabaseConfigured || !getSupabase()) return undefined;
    if (!isLoggedInStorage() || isGuestStorage()) return undefined;
    if (ran.current) return undefined;
    ran.current = true;

    let cancelled = false;
    (async () => {
      try {
        const me = await fetchMyAppUserRow();
        if (cancelled || !me?.id) return;
        const awarded = await tryAwardDailyLogin(me.id);
        if (awarded) showToast(t('points.toastAwarded', { amount: 10 }));
      } catch {
        /* offline */
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [showToast, t]);
}
